import { useSyncExternalStore } from 'react';
import { GAMES, getEnabledGames, subscribeEnabledGames, type GameInfo } from '../types/lottery';

export function useEnabledGames(): GameInfo[] {
  const list = useSyncExternalStore(subscribeEnabledGames, getEnabledGames, getEnabledGames);
  return list.length > 0 ? list : GAMES;
}
